const LOCAL_STORAGE_KEYS = {
	PLATFORM: "platform",
	MATOMO_CONSENT: "matomo_consent",
	MATOMO_OPT_OUT: "matomo_optout",
} as const;

export type LocalStorageKey =
	(typeof LOCAL_STORAGE_KEYS)[keyof typeof LOCAL_STORAGE_KEYS];

export default LOCAL_STORAGE_KEYS;
